var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.clase ? 'position' : ''},[_c('div',{staticClass:"spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }